var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWbgAddedSugarV2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 16,
    fill: "#E9EBEC"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_714_77604)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.1524 22.5C6.7611 22.5 4 19.9925 4 16.9101C4 16.681 4.18656 16.4936 4.41458 16.4936H15.4217C16.0228 16.152 16.4415 15.9104 16.6322 15.7938C21.1138 13.0363 23.8045 12.9322 25.4089 12.8697H25.5498C25.5498 12.8697 25.5954 12.8572 25.6286 12.8572H26.7687C27.4486 12.8572 28 13.4112 28 14.0943C28 14.7775 27.4486 15.3314 26.7687 15.3314H25.811C25.811 15.3314 25.7861 15.3314 25.7737 15.3314C19.7789 15.573 15.2185 20.1049 15.1729 20.1507C15.1688 20.1549 15.1605 20.1632 15.1563 20.1674C13.9997 21.6336 12.1382 22.5041 10.1524 22.5041V22.5Z",
    fill: "#585C60"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.08892 15.4231V11.995L9.95367 13.1905V15.4231H14.4767V11.3702C14.4767 11.3702 14.4767 11.3661 14.4767 11.3619C14.4767 11.3577 14.4767 11.3494 14.4767 11.3452C14.4767 11.3036 14.4643 11.2619 14.4477 11.2203C14.4477 11.2119 14.4394 11.2036 14.4353 11.1911C14.4145 11.1495 14.3897 11.112 14.3565 11.0786C14.3482 11.0703 14.3441 11.0661 14.3358 11.062C14.3192 11.0495 14.3068 11.0328 14.2902 11.0245C14.2694 11.012 14.2446 10.9995 14.2238 10.9912C14.2238 10.9912 14.2155 10.987 14.2114 10.9828L10.5382 9.53331H10.5258C10.5258 9.53331 10.4926 9.52498 10.476 9.52081C10.4429 9.51248 10.4097 9.50415 10.3724 9.50415C10.3392 9.50415 10.3061 9.51248 10.2687 9.52081C10.2522 9.52498 10.2356 9.52081 10.219 9.52914H10.2066C10.2066 9.52914 10.2066 9.53331 10.2066 9.53747L6.5251 10.9828C6.5251 10.9828 6.51681 10.987 6.51681 10.9912C6.49193 10.9995 6.4712 11.012 6.44633 11.0245C6.42974 11.037 6.41731 11.0495 6.40072 11.062C6.39243 11.0661 6.38414 11.0745 6.37999 11.0786C6.34683 11.112 6.32195 11.1495 6.30122 11.1911C6.29708 11.1994 6.29293 11.2078 6.28879 11.2203C6.2722 11.2619 6.26391 11.3036 6.25977 11.3452C6.25977 11.3494 6.25977 11.3577 6.25977 11.3619C6.25977 11.3619 6.25977 11.3661 6.25977 11.3702V15.4231H7.08892ZM10.3682 10.3622L12.9552 11.3827L10.3682 12.4615L7.78127 11.3827L10.3682 10.3622Z",
    fill: "#585C60"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_714_77604"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 13,
    fill: "white",
    transform: "translate(4 9.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWbgAddedSugarV2);
export default __webpack_public_path__ + "static/media/wbg-added-sugar-v2.bcbfe48dbfba96741d93866bd991fe53.svg";
export { ForwardRef as ReactComponent };